export default "__VITE_ASSET__ZZdFuCyP__"